module.exports = __webpack_public_path__ + "img/slide2_vn.6ec6acce.jpg";